import { api, unwrap, type components } from '@/core/http';
import type { Brand, Packaging, Product } from '../domain/product';

type ProductOut = components['schemas']['ProductOut'];

/** Contrato da API (snake_case) → linguagem do front. */
export function toProduct(p: ProductOut): Product {
  return {
    id: p.id,
    slug: p.slug,
    name: p.name,
    summary: p.summary,
    brand: p.brand as Brand,
    packaging: p.packaging as Packaging,
    bestSeller: p.best_seller,
    imageUrl: p.image_url ?? undefined,
    details: {
      description: p.details.description.map((b) => ({
        title: b.title ?? undefined,
        paragraphs: b.paragraphs,
      })),
      composition: p.details.composition.map((c) => ({
        ingredient: c.ingredient,
        amount: c.amount ?? undefined,
      })),
      usage: p.details.usage.map((b) => ({ title: b.title ?? undefined, paragraphs: b.paragraphs })),
    },
  };
}

/** Produtos publicados — públicos, sem login (gerenciados no backoffice). */
export const productsApi = {
  list: async (): Promise<Product[]> =>
    (await unwrap(api.GET('/v1/products/public', { params: { query: { limit: 500 } } }))).map(toProduct),
};
